import { Component, OnInit, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { ToastrService } from 'ngx-toastr';
import { GeneralService } from '../../../services/general.service';
import { GroupService } from '../../../services/group.service';
import { TranslateService } from 'ng2-translate/ng2-translate';

@Component({
  selector: 'app-authorizers-detail',
  templateUrl: './authorizers-detail.component.html',
  styleUrls: ['./authorizers-detail.component.scss']
})
export class AuthorizersDetailComponent implements OnInit {
  userId: any;
  userToken: any;
  textButton: any;
  loadBtn = false;
  type: any;
  listUsersPortal: any = [];
  info: any;
  editId: any;
  send: any = {};

  constructor(private toastr: ToastrService,
              private gralService: GeneralService,
              private groupService: GroupService,
              public  dialogRef: MatDialogRef<AuthorizersDetailComponent>,
              public  translate: TranslateService,
              @Inject(MAT_DIALOG_DATA) public data: any) {
                translate.addLangs(['es', 'en']);
                translate.setDefaultLang('es');

    this.type = this.data.type;
    this.userId = this.data.userId;
    this.userToken = this.data.userToken;
    this.listUsersPortal = this.data.listUsersPortal;
    this.info = this.data.info;
    this.send.user = this.info.usuarioSAP;

    if(this.type === 'assign'){
      this.textButton = 'BUTTONS.ASSIGN';
    }else{
      console.log(this.info);
      this.editId = this.data.id;
      this.textButton = 'BUTTONS.REASIGN';
    }
  }

  ngOnInit() {
  }

  onCloseConfirm(){
    if(!this.send.userAuth){
      //this.toastr.error( 'Favor de seleccionar el usuario autorizador' , 'Asignar usuario');
      this.toastr.error( this.translate.instant('AC.AUTUSER') , this.translate.instant('AC.ASIGNUSER') );
      return;
    }
    const params = {idUsuarioSAP: this.info.idAutorizadorSAP, idUsuarioPortal: this.send.userAuth};
    this.groupService.assignUserAuth(params, this.userId, this.userToken).then((data) => {
      this.loadBtn = false;
      if(data['procesoCorrecto']){
        if(this.type === 'assign') {
          //this.toastr.success('Usuario asignado correctamente', 'Asignar usuario');
          this.toastr.success( this.translate.instant('AC.SUCASSUSE') , this.translate.instant('AC.ASIGNUSER') );
        }else{
          //this.toastr.success('Usuario reasignado correctamente', 'Reasignar usuario');
          this.toastr.success( this.translate.instant('AC.SUCREAUSE') , this.translate.instant('AC.REASIGNUSER') );
        }
        this.dialogRef.close({pendientesPorAsignar: data['pendientesPorAsignar'], usuariosAsignados: data['usuariosAsignados']});
      }else{
        //this.toastr.error(data['lsMensajes'][0].value, 'Asignar usuario');
        this.toastr.error(data['lsMensajes'][0].value, this.translate.instant('AC.ASIGNUSER') );
        return;
      }
    }, (err) => {
      console.log(err);
      this.loadBtn = false;
      //this.toastr.error(JSON.stringify(err), 'Asignar usuario');
      this.toastr.error(JSON.stringify(err), this.translate.instant('AC.ASIGNUSER') );
      if(err.status == 401){
        this.gralService.actDeacUser(false);
      }
    });
  }

  onCloseCancel() {
    this.dialogRef.close();
  }

}
